var _circle, _circle2, _circle3, _path, _path2, _path3, _path4, _circle4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHurt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    fill: "none",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 18,
    stroke: "#38bdf8",
    strokeWidth: 1.5,
    strokeOpacity: 0.35
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 21,
    r: 2,
    fill: "#fafcfb"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 21,
    r: 2,
    fill: "#fafcfb"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 18 Q17 17 18 18",
    stroke: "#38bdf8",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30 18 Q31 17 32 18",
    stroke: "#38bdf8",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18 33 Q24 29 30 33",
    stroke: "#fafcfb",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14 30 Q12 34 14 38",
    stroke: "#38bdf8",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    fill: "none"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 38,
    r: 1.5,
    fill: "#38bdf8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHurt);
export default __webpack_public_path__ + "static/media/hurt.d706184db41212eb231c5677fe1939e3.svg";
export { ForwardRef as ReactComponent };